import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ScheduleRegisterState, scheduleRegisterFeatureKey } from './schedule-register.reducer';

const scheduleRegisterSelector = createFeatureSelector<ScheduleRegisterState>(scheduleRegisterFeatureKey);

export const selectFilters = createSelector(scheduleRegisterSelector, (state) => {
   return state.filters;
});

export const selectEntities = createSelector(scheduleRegisterSelector, (state) => {
   return state.entities;
});
